export default {
  LOAD_PLANNING_STREAM (state, payload) {
    state.planningStream = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/widget/vuex/mutations.js